import styled from 'styled-components'
import { BLACK, CRIMSON_500, LIGHT_YELLOW, NEUTRAL_100, NEUTRAL_300 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TitleContainer = (styled.span`
  font-family: ${INTER.medium};
  color: ${BLACK};
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const OptionalText = (styled.span`
  color: ${NEUTRAL_300};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

interface StyledInputProps {
  $isError: boolean;
  $borderless?: boolean;
}

export const StyledInput = (styled.input<StyledInputProps>`
  width: 100%;
  border: ${(props: StyledInputProps) => props.$borderless ? 'none' : `1px solid ${props.$isError ? CRIMSON_500 : NEUTRAL_100}`};
  border-radius: 8px;
  padding: ${(props: StyledInputProps) => props.$borderless ? '0' : '12px 14px'};
  color: ${(props: StyledInputProps) => props.$isError ? CRIMSON_500 : BLACK};
  font-family: ${INTER.regular};
  font-size: 13px;
  outline: none;
  background-color: ${(props: StyledInputProps) => props.$isError ? LIGHT_YELLOW : 'transparent'};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ErrorText = (styled.span`
  color: ${CRIMSON_500};
  font-family: ${INTER.regular};
  font-size: 12px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
